var a = /* @__PURE__ */ ((r) => (r.DOWN = "ArrowDown", r.UP = "ArrowUp", r.RIGHT = "ArrowRight", r.LEFT = "ArrowLeft", r))(a || {}), E = /* @__PURE__ */ ((r) => (r.ESCAPE = "Escape", r.TAB = "Tab", r.ENTER = "Enter", r))(E || {});
export {
  a as K,
  E as a
};
